/* eslint-disable react/no-danger */
import React, { useState } from 'react';
import { Avatar, AvatarGroup, Button, Tag, Text } from 'src/@vymo/ui/atoms';
import classnames from 'classnames';
import { ReactComponent as DownIcon } from 'src/assets/icons/down.svg';
import { ReactComponent as LockIcon } from 'src/assets/icons/lock-line.svg';
import { ReactComponent as ReplyIcon } from 'src/assets/icons/reply-line.svg';
import { ReactComponent as UpIcon } from 'src/assets/icons/up.svg';
import { Keys, locale } from 'src/i18n';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import {
  getFormattedNoteDate,
  getNoteAuthorInitial,
  getReplyButtonLabel,
} from '../queries';
import { getThreadNotes } from '../selectors';
import { setIsParentEditorActive } from '../slice';
import { NoteProps } from '../types';
// eslint-disable-next-line import/no-cycle
import NotesReplyView from './replies';
import styles from './index.module.scss';

function Note({ note, isThreadNote, classNames = '' }: NoteProps) {
  const {
    added_by: addedBy,
    note: content,
    created_date: createdDate,
    childs,
    threads_user: threadUsers,
    _id: id,
    vo_id: voId,
    visibility,
  } = note;
  const { name } = addedBy;
  const [showReplyView, setShowReplyView] = useState(false);
  const [showReplyButton, setShowReplyButton] = useState(true);
  const dispatch = useAppDispatch();
  const childNotesLength = useAppSelector((state) =>
    getThreadNotes(state, id),
  )?.length;

  let footer: any = null;
  if (!isThreadNote && childs > 0) {
    footer = (
      <div className={styles.noteView__note__content__footer}>
        <AvatarGroup
          items={(threadUsers || []).map((user) => ({
            text: getNoteAuthorInitial(user.name),
          }))}
          size="medium"
        />
        <Button
          iconProps={{
            icon: !showReplyView ? <DownIcon /> : <UpIcon />,
            iconPosition: 'right',
          }}
          type="text"
          onClick={() => {
            dispatch(setIsParentEditorActive(showReplyView));
            setShowReplyView(!showReplyView);
          }}
        >
          {getReplyButtonLabel(childNotesLength || childs, showReplyView)}
        </Button>
      </div>
    );
  } else if (!isThreadNote && showReplyButton && visibility !== 'private') {
    footer = (
      <Button
        isIcon
        iconProps={{ icon: <ReplyIcon />, iconPosition: 'left' }}
        size="small"
        onClick={() => {
          setShowReplyView(!showReplyView);
          setShowReplyButton(false);
        }}
        variant="subtle"
      />
    );
  }

  return (
    <div className={classnames(classNames, styles.noteView__note)}>
      <Avatar text={getNoteAuthorInitial(addedBy?.name)} />
      <div className={styles.noteView__note__content}>
        <div className={styles.noteView__note__content__info}>
          <div className={styles.noteView__note__content__info__header}>
            <Text type="h5">{name}</Text>
            <Text type="sublabel">{getFormattedNoteDate(createdDate)}</Text>
            {visibility === 'private' && (
              <Tag
                label={locale(Keys.VISIBLE_TO_YOU)}
                leftIcon={{ icon: <LockIcon /> }}
                className={
                  styles.noteView__note__content__info__header__visibilityIcon
                }
              />
            )}
          </div>
          <div className={styles.noteView__note__content__message}>
            <span dangerouslySetInnerHTML={{ __html: content }} />
          </div>
        </div>

        {footer}

        {showReplyView && (
          <NotesReplyView
            setShowReplyView={() => {
              setShowReplyView(false);
              setShowReplyButton(true);
              dispatch(setIsParentEditorActive(true));
            }}
            voId={voId}
            id={id}
            childs={childs}
            visibility={visibility}
          />
        )}
      </div>
    </div>
  );
}

export default Note;
